<template>
  <div class="form-file">
    <vue-dropzone
      ref="dropzone"
      :id="id"
      :options="dropzoneOptions"
      :include-styling="false"
      :use-custom-slot="true"
      @vdropzone-upload-progress="onUploadProgress"
      @vdropzone-file-added="onFileAdded"
      @vdropzone-error="onError"
      @vdropzone-complete="onComplete"
      @vdropzone-success="onSuccess"
      @vdropzone-sending="onSending"
    >
      <slot></slot>
    </vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";

export default {
  name: "AppFormFile",
  components: { vueDropzone: vue2Dropzone },
  props: {
    value: {
      type: Object,
      required: false,
      default: null,
    },
    url: {
      type: String,
      required: true,
      default: null,
    },
    maxFilesize: {
      type: Number,
      required: false,
      default: 2,
    },
    acceptedFiles: {
      type: String,
      required: false,
      default: null,
    },
    paramName: {
      type: String,
      required: false,
      default: "file",
    },
    autoUpload: {
      type: Boolean,
      required: false,
      default: true,
    },
    timeout: {
      type: Number,
      required: false,
      default: 30000,
    },
  },
  computed: {
    dropzoneOptions() {
      return this.getDropzoneOptions();
    },
  },
  methods: {
    getDropzoneOptions() {
      return Object.assign({}, this.defaultDropzoneOptions, {
        url: this.url,
        maxFilesize: this.maxFilesize,
        acceptedFiles: this.acceptedFiles,
        paramName: this.paramName,
        autoProcessQueue: this.autoUpload,
        timeout: this.timeout,
      });
    },
    onUploadProgress(file, progress, bytesSent) {
      this.$emit("progress", file, {
        percent: progress,
        sent: bytesSent,
        total: file.size,
      });
    },
    onFileAdded(file) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.$emit("add", file, reader.result);
      });

      reader.readAsDataURL(file);
    },
    onError(file, message, xhr) {
      this.$emit("error", file, message, xhr);
    },
    onSuccess(file, response) {
      this.$emit("input", response);
      this.$emit("success", file, response);
    },
    onComplete(response) {
      this.$emit("complete", response);
    },
    onSending(file, xhr, formData) {
      this.$emit("sending", file, xhr, formData);
    },
    acceptedFileExtensions() {
      if (!this.acceptedFiles) {
        return "";
      }

      return this.acceptedFiles.map(f => f.split("/")[1]).join(", ");
    },
  },
  data() {
    return {
      id: `form-file-${Math.ceil(Math.random() * 10000000000000)}`,
      defaultDropzoneOptions: {
        withCredentials: true,
        clickable: true,
        ignoreHiddenFiles: true,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: false,
        dictFileTooBig: this.$trans("validation.upload.file_too_big"),
        dictInvalidFileType: this.$trans(
          "validation.upload.invalid_file_type",
          { files: this.acceptedFileExtensions }
        ),
        addedfile: () => {},
      },
    };
  },
};
</script>
